import { IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

export const FORMAT_SCORE_PERCENTAGE = (
	score,
) => {
    if (IS_NULL_OR_UNDEFINED(score)) {
		return;
	}

	if (score < 0.01) {
		return '< 1 %'
	} else {
		return Math.round(score * 100) + '%'
	}
};
